document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('[data-hero-slide]')];
    const dots = [...carousel.querySelectorAll('[data-hero-dot]')];
    const previous = carousel.querySelector('[data-hero-prev]');
    const next = carousel.querySelector('[data-hero-next]');
    const toggle = carousel.querySelector('[data-hero-toggle]');
    const status = carousel.querySelector('[data-hero-status]');
    const currentScent = carousel.querySelector('[data-hero-current]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = carousel.dataset.autoplay === 'true';
    const interval = Math.max(3000, Number(carousel.dataset.interval) || 5000);
    let index = 0;
    let timer;
    let paused = !autoplay;

    const show = (nextIndex, announce = false) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === index)));
      if (currentScent) currentScent.textContent = slides[index]?.dataset.scent || '';
      if (announce && status) status.textContent = dots[index]?.getAttribute('aria-label') || '';
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = undefined;
    };
    const start = () => {
      stop();
      if (!paused && !reduceMotion && document.visibilityState === 'visible') timer = window.setInterval(() => show(index + 1), interval);
    };
    const move = (direction) => {
      show(index + direction, true);
      start();
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => {
      show(dotIndex, true);
      start();
    }));
    toggle?.addEventListener('click', () => {
      paused = !paused;
      toggle.textContent = paused ? '▶' : 'Ⅱ';
      toggle.setAttribute('aria-label', paused ? carousel.dataset.playLabel : carousel.dataset.pauseLabel);
      if (paused) stop(); else start();
    });
    if (toggle) {
      toggle.textContent = paused ? '▶' : 'Ⅱ';
      toggle.setAttribute('aria-label', paused ? carousel.dataset.playLabel : carousel.dataset.pauseLabel);
      if (reduceMotion) toggle.hidden = true;
    }
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', (event) => {
      if (!carousel.contains(event.relatedTarget)) start();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') stop(); else start();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) start(); else stop();
      }, { threshold: 0.2 }).observe(carousel);
    } else {
      start();
    }
  });
});
